import { INews } from '../../types/developer/news';
import { IApplicationState } from '../../types/redux';
import { format, isValid, parseISO } from 'date-fns';

const emptyNews = Array.of<INews>();

export function getNews(state: IApplicationState) {
  if (state.fsk?.news) {
    return state.fsk.news.map((item, index) => {
      const parsedDate = parseISO(item.date);

      return {
        id: index,
        title: item.text,
        date: isValid(parsedDate) ? format(parseISO(item.date), 'dd.MM.yy') : '',
      };
    });
  }

  if (!state.developer) {
    return emptyNews;
  }

  return state.developer.news;
}
